var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" What to Expect ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-sheet", [
                        _c("p", [
                          _vm._v(
                            "To get started, we will ask a few simple questions about your project or company and what type of website you would like to create."
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            "Once your request is submitted, our team will use the elements provided and start working on your new custom multi-page Starter Site."
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [_c("h4", [_vm._v("How Long Does It Take?")])]
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-sheet", [
                        _c("p", [
                          _vm._v(
                            "We typically complete requests within 24-72 hours and process Starter Site requests on a first-come, first-served basis."
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            "Our Starter Site team will contact you once the draft website is ready or if additional information is required."
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }